import { Grid, Typography } from "@mui/material";
import { SerialCommandSender } from "./serialCommandSender";
import { SerialMessageList } from "./serialMessageList";

export const SerialInterface = ({ title, socketUrl }) => {

    return (
        <>
            <Grid item xs={6} sm={6}>
                <Typography>
                    {title}
                </Typography>
                <SerialCommandSender socketUrl={socketUrl} />
                <SerialMessageList socketSerialDataEvent={'ON_MESSAGE' + socketUrl + 'serialMsg'} />
            </Grid>
        </>
    )
}

export default SerialInterface;